









  
setTimeout(function(){

    // Only for sale
	
	if(window.location.pathname.indexOf('/collections/sale') == -1) {
		return false;
	}

	var productGridRow = document.querySelector('#ProductGridContainer')?.closest('.row');
	if (!productGridRow) {
		return;
	}
	
	
	
	

	/*
		BEGIN OF ACTIONS
	*/
	
	var brandList = document.createElement('div');
brandList.className = 'brandList';
var brandListBrands = document.createElement('div');
brandListBrands.className = 'brands';


saleBrands = [];

var currentDateObject = new Date();
var currentDate = currentDateObject.toISOString().split('T')[0];
var currentTime = currentDateObject.toISOString().split('T')[1].substring(0,5);

if((currentDate == '2025-06-28' && currentTime >= '05:00') || currentDate > '2025-06-28') {
	saleBrands.push([
		'https://ricomoda.com/collections/sale-stone-island',
		'https://ricomoda.com/cdn/shop/files/logo-stone-island.svg?v=1719389516&width=1100'
	]);
}
if((currentDate == '2025-06-26' && currentTime >= '09:00') || currentDate > '2025-06-26') {
	saleBrands.push([
		'https://ricomoda.com/collections/sale-c-p-company',
		'https://ricomoda.com/cdn/shop/files/logo-cp-company.svg?v=1719389516&width=1100'
	]);
}
if((currentDate == '2025-06-28' && currentTime >= '05:00') || currentDate > '2025-07-01') {
	saleBrands.push([
		'https://ricomoda.com/collections/sale-jacob-cohen',
		'https://ricomoda.com/cdn/shop/files/jacob_cohen_2024.jpg?v=1719388430&width=770'
	]);
}
if((currentDate == '2025-06-28' && currentTime >= '05:00') || currentDate > '2025-06-28') {
	saleBrands.push([
		'https://ricomoda.com/collections/sale-parajumpers',
		'https://ricomoda.com/cdn/shop/files/logo-parajumpers.svg?v=1719389516&width=1100'
	]);
}


saleBrands.push([
	'https://ricomoda.com/collections/sale-ami-paris',
	'https://ricomoda.com/cdn/shop/files/f356acc68645c032869cac2825f23b97.png?v=1739791707&width=720'
]);
saleBrands.push([
		'https://ricomoda.com/collections/sale-olaf',
		'https://media.findlab.nl/ricomoda/logo-olaf.jpg'
]);
saleBrands.push([
		'https://ricomoda.com/collections/sale-new-amsterdam-surf-association',
		'https://media.findlab.nl/ricomoda/na-logo.png'
]);
saleBrands.push([
		'https://ricomoda.com/collections/sale-genti',
		'https://media.findlab.nl/ricomoda/genti-logo.jpg'
]);
saleBrands.push([
		'https://ricomoda.com/collections/sale-nn-07',
		'https://media.findlab.nl/ricomoda/nn07-logo.jpg'
]);
saleBrands.push([
		'https://ricomoda.com/collections/sale-polo-ralph-lauren',
		'https://cdn.shopify.com/s/files/1/0579/3995/1718/files/POLO_RL_Black.png?v=1766397004'
]);
saleBrands.push([
		'https://ricomoda.com/collections/sale-brams-fruit',
		'https://media.findlab.nl/ricomoda/logo-brams.png'
]);
saleBrands.push([
		'https://ricomoda.com/collections/sale-flaneur',
		'https://media.findlab.nl/ricomoda/logo-flaneur.png'
]);


for(s=0; s < saleBrands.length; s++) {
	brandListBrands.innerHTML += '<span class="listBrand"><a href="'+saleBrands[s][0]+'"><img src="'+saleBrands[s][1]+'" /></a></span>';
}
brandList.append(brandListBrands);
brandList.innerHTML += '<div class="allBrands"><a href="javascript:void(0);" onclick="document.getElementsByClassName(\'facets-toggle\')[0].click();">Bekijk alle SALE merken</a></div>';

var brandListStyle = document.createElement('style');
brandListStyle.innerHTML = '.brandList .brands { display: flex; flex-direction: row; flex-wrap: wrap; justify-content: space-evenly; width: 100%; column-gap: 30px; } ';
brandListStyle.innerHTML += '.brandList { padding-bottom: 10px; border-bottom: 2px solid #000; margin-bottom: 15px; } ';
brandListStyle.innerHTML += '.listBrand { flex: 0 0 13% } @media screen and (max-width: 768px) { .listBrand { flex: 0 0 17% } }  @media screen and (max-width: 600px) { .listBrand { flex: 0 0 29% } } ';
brandListStyle.innerHTML += '.listBrand img { width: 100%; position: relative; top: 50%; left: 50%; transform: translate(-50%, -50%); max-width: 66%; }  @media screen and (max-width: 768px) { .listBrand img { max-width: 100%; } } ';
brandListStyle.innerHTML += '.allBrands { text-align: center; padding: 14px 0 0 0; font-size: .83em; } .allBrands a { text-decoration: underline; } ';

productGridRow.prepend(brandList);

document.querySelector('body').append(brandListStyle);


	/*
		END OF ACTIONS
	*/
	


  
  
  
}, 500);
